import { render, staticRenderFns } from "./TipDialog.vue?vue&type=template&id=737836ee&scoped=true&"
import script from "./TipDialog.vue?vue&type=script&lang=js&"
export * from "./TipDialog.vue?vue&type=script&lang=js&"
import style0 from "./TipDialog.vue?vue&type=style&index=0&id=737836ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737836ee",
  null
  
)

export default component.exports